import React from "react"
import Img from "gatsby-image"
import { StaticQuery, graphql } from "gatsby"

import {
  ParagraphDaintree,
  Heading1Red,
  Wrapper,
  WrapperTorchRed,
  DotsVertical,
  DotVertical,
  Inner,
  Row,
  Col6WithPadding,
  Col12,
  HandleImageWidthXSmall,
  UnordedList,
} from "../../styles/styles"

const Section5 = ({ data }) => (
  <>
    <Wrapper>
      <DotsVertical>
        <DotVertical />
        <DotVertical />
        <DotVertical />
      </DotsVertical>
      <Row>
        <Col12>
          <Inner>
            <HandleImageWidthXSmall>
              <Img
                fluid={data.logo.childImageSharp.fluid}
              />
            </HandleImageWidthXSmall>
            <Heading1Red>PACIFIC KAIJU IS A BRAND FOR SALE</Heading1Red>
          </Inner>
        </Col12>
      </Row>
    </Wrapper>
    <WrapperTorchRed>
      <DotsVertical>
        <DotVertical />
        <DotVertical />
        <DotVertical />
      </DotsVertical>
      <Row>
        <Col6WithPadding>
          <ParagraphDaintree>
            Pacific Kaiju is a conceptual premium lifestyle brand and esports organization that was
            designed by <a href="https://www.vanessabrewster.com/" target="_blank" rel="noopener noreferrer">Vanessa Brewster</a> and conceptualised by <a href="srrycmpny.com" targe="_blank" rel="noopener noreferrer">Sorry Company</a>.
          </ParagraphDaintree>
          <ParagraphDaintree>
            The brand attempts to sit within the intersection of competitive gaming and premium apparel appealing to both the hardcore competitive gamer and the casual who doesn't identify with the traditional `gamer` cliche.
          </ParagraphDaintree>
          <ParagraphDaintree>
            © {new Date().getFullYear()}, Sorry Company
          </ParagraphDaintree>
        </Col6WithPadding>
        <Col6WithPadding>
          <ParagraphDaintree>
            Like any good brand, Pacific Kaiju is for sale. The current asking price is $10,000USD.
            What you get:
          </ParagraphDaintree>
          <UnordedList>
            <li>— Name</li>
            <li>— URL</li>
            <li>— Twitter account</li>
            <li>— Twitch account</li>
            <li>— Gmail account</li>
            <li>— Discord account</li>
            <li>— YouTube account</li>
            <li>— 10+ logo & other designs</li>
            <li>— 4 repeating patterns</li>
            <li>— 1 launching soon website design</li>
            <li>— 4 app icons</li>
            <li>— Branding book</li>
            <li>— 30 hours custom design*</li>
            <li>— 30 hours custom web developement*</li>
          </UnordedList>
          <ParagraphDaintree>
            *For transitioning the brand to the buyer’s needs
          </ParagraphDaintree>
          <ParagraphDaintree>
            All enquiries please email: <a href="mailto:srrycmpny@gmail.com">srrycmpny@gmail.com</a>
          </ParagraphDaintree>
        </Col6WithPadding>
      </Row>
    </WrapperTorchRed>
  </>
)

export default props => (
  <StaticQuery
    query={graphql`
      query {
        laptopDark: file(relativePath: { eq: "LaptopDark@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        logo: file(relativePath: { eq: "pacific_kaiju_logolockups_icon_RGB@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => <Section5 data={data} {...props} />}
  />
)
